<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.databases')"
      show_usermenu
    ></my-header>
    <el-dialog
      :visible.sync="deleteDialog"
      width="40%"
    >
    <span slot="title" class="delete-dialog-title"> <div>{{ $t('bases.selectActionWithBase') }}</div> <div class="delete-dialog-element-name">{{baseName}}</div> </span>
      <div v-if="getSectionsInBaseArray.length > 0">
        {{ $t('bases.quanityOfTetheredApps') + ' ' + getSectionsInBaseArray.length }}
        <br />{{ $t('bases.selectAppsFromWhichUntieBase') }}
        <el-select v-model="sectionsToUnlink" multiple filterable>
          <el-option
            v-for="(section, index) in getSectionsInBaseArray"
            :key="index"
            :label="section.name"
            :value="section.idSection"
          ></el-option>
        </el-select>
        <el-radio v-model="deleteRadio" label="unlink"
          >{{ $t('bases.untieBaseOfSelectedApps') }}</el-radio
        >
      </div>
      <div v-else>{{ $t('bases.noAppsAttachedToBase') }}</div>
      <el-radio v-model="deleteRadio" label="hard">{{ $t('bases.deleteBase') }}</el-radio>

      <div class="buttons-bottom">
        <div></div>
        <div>
          <el-button
            class="button-cancel"
            type="plain"
            @click="deleteDialog = false"
            >{{ $t('bases.cancel') }}</el-button
          >
          <el-button
            class="button-confirm"
            type="success"
            @click="okClickDelete"
            >ОК</el-button
          >
        </div>
      </div>
    </el-dialog>
    <reference-grid
      :gridData="getBasesTableArray"
      :columns="columnDefs"
      gridType="db"
      @deleteClicked="deleteClick"
    ></reference-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import ReferenceGrid from "../../components/reference/ReferenceGrid";
import { mapGetters } from "vuex";
import i18n from "@/locales";
export default {
  data() {
    return {
      currentId: null,
      baseName: null,
      sectionsToUnlink: [],
      columnDefs: [],
      deleteDialog: false,
      deleteRadio: "",
    };
  },
  methods: {
    deleteClick({currentId, title}) {
      this.currentId = currentId;
      this.baseName = title;
      this.deleteRadio = "";
      this.sectionsToUnlink = [];
      this.$store.dispatch("getSectionsInBase", currentId).then(() => {
        this.deleteDialog = true;
      });
    },
    okClickDelete() {
      if (this.sectionsToUnlink.length > 0 && this.deleteRadio === "unlink") {
        this.$store.commit("setLoading", true);
        this.$store
          .dispatch("unlinkBaseInReference", {
            idBase: this.currentId,
            idSection: this.sectionsToUnlink,
          })
          .then(() => {
            return this.$store.dispatch("getBaseTable");
          })
          .then(() => {
            this.deleteDialog = false;
            this.deleteRadio = "";
            this.$store.commit("setLoading", false);
          })
          .catch(() => {
            this.deleteDialog = false;
            this.deleteRadio = "";
            this.$store.commit("setLoading", false);
          });
      } else if (this.deleteRadio === "hard") {
         this.$confirm(
           this.$t('bases.thisActionDeleteBaseWholly'),
          {
            confirmButtonText: "OK",
            cancelButtonText: this.$t('bases.cancellation'),
            type: "warning",
          }
        ).then(()=>{
            this.$store.commit("setLoading", true);
            this.$store
              .dispatch("delBaseTable", this.currentId)
              .then(() => {
                return this.$store.dispatch("getBaseTable");
              })
              .then(() => {
                this.deleteDialog = false;
                this.deleteRadio = "";
                this.$store.commit("setLoading", false);
              })
              .catch(()=>{})
            })
          .catch(() => {
            this.deleteDialog = false;
            this.deleteRadio = "";
            this.$store.commit("setLoading", false);
          });
      } else if (
        this.deleteRadio === "unlink" &&
        this.sectionsToUnlink.length === 0
      ) {
        this.$store.commit("setError", this.$t('bases.cancellation'));
      } else if (this.deleteRadio === "") {
        this.$store.commit("setError", this.$t('bases.cancellation'));
      }
    },
  },
  created() {
    this.$store.commit("setLoading", true);
    this.columnDefs = [
      { headerName: i18n.t("tableHeaders.database.name"), field: "baseName" },
      { headerName: i18n.t("tableHeaders.database.alias"), field: "baseAlias" },
      {
        headerName: i18n.t("tableHeaders.database.baseType"),
        field: "baseTypeName",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.database.server"),
        field: "baseServerName",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.database.comment"),
        field: "baseComment",
      },
    ];
    this.$store.dispatch("getBaseTable").catch(() => {
      this.$store.commit("setLoading", false);
    });
  },
  computed: {
    ...mapGetters(["getBasesTableArray", "getSectionsInBaseArray"]),
  },
  components: {
    myHeader: Header,
    ReferenceGrid,
  },
};
</script>

<style scoped>
.delete-dialog-element-name{
  font-weight: 600;
  text-align: center;
}
</style>